// extracted by mini-css-extract-plugin
export default {"heading":"Heading_heading__k0Ay3","underline":"Heading_underline__6PPW2"};